import React from 'react'
import {Box, Skeleton, Stack} from '@mui/material'
import {PAYMENT_COLORS} from './constants'

export default function GatewayCardSkeleton() {
  return (
    <Box
      sx={{
        p: '24px',
        borderRadius: '12px',
        border: `1px solid ${PAYMENT_COLORS.border}`,
        backgroundColor: PAYMENT_COLORS.surface,
        minHeight: 280,
        '@keyframes shimmer': {
          '0%': {opacity: 0.55},
          '50%': {opacity: 1},
          '100%': {opacity: 0.55},
        },
        animation: 'shimmer 1.4s ease-in-out infinite',
      }}
    >
      <Stack direction='row' justifyContent='space-between' mb={2}>
        <Skeleton variant='circular' width={96} height={96} />
        <Skeleton variant='rounded' width={88} height={24} />
      </Stack>
      <Skeleton width='60%' height={24} sx={{mb: 1}} />
      <Skeleton width='40%' height={18} sx={{mb: 2}} />
      <Skeleton width='80%' height={16} sx={{mb: 0.5}} />
      <Skeleton width='70%' height={16} sx={{mb: 2}} />
      <Skeleton variant='rounded' width='100%' height={40} />
    </Box>
  )
}
